import React, { useState } from "react";
import { motion } from "framer-motion";
import { fetchFromAPI } from "../lib/api";

const accordioni = [
  { year: "2000", title: "Divine Coronation", image: "https://firebasestorage.googleapis.com/v0/b/bcs-website-assets.appspot.com/o/pastevent%2Fcoronation1.jpg?alt=media&token=5a2073d1-e3b9-4056-b5fa-54452dad5a0b" },
  { year: "2004", title: "Eternal Dominion", image: "https://firebasestorage.googleapis.com/v0/b/bcs-website-assets.appspot.com/o/pastevent%2Fpastevent1.jpeg?alt=media&token=8e81abae-3f1b-4070-94e7-036f95366b88" },
  { year: "2005", title: "Eternal Redeeming Covenant", image: "https://firebasestorage.googleapis.com/v0/b/bcs-website-assets.appspot.com/o/pastevent%2Fpastevent5.jpeg?alt=media&token=09ef570e-1b72-4838-a87b-38b1a98b846c" },
  { year: "2007", title: "Seal of the Living God", image: "https://firebasestorage.googleapis.com/v0/b/bcs-website-assets.appspot.com/o/pastevent%2Fevent9.jpeg?alt=media&token=9cdd5646-08e6-4b16-8cc8-7bc923d5de19" },
  { year: "2008", title: "March of the Redeemed / Golden Jubilee", image: "https://firebasestorage.googleapis.com/v0/b/bcs-website-assets.appspot.com/o/pastevent%2Fevent13.jpeg?alt=media&token=0a3a4088-4253-413f-949a-db964656acb2" },
  { year: "2009", title: "Divine Anointing", image: "https://firebasestorage.googleapis.com/v0/b/bcs-website-assets.appspot.com/o/pastevent%2Fevent18.jpeg?alt=media&token=c605cbff-78d1-4246-9d76-e23de9cb0958" },
  { year: "2010", title: "My Redeemer Liveth", image: "https://firebasestorage.googleapis.com/v0/b/bcs-website-assets.appspot.com/o/pastevent%2Fpastevent1.jpeg?alt=media&token=8e81abae-3f1b-4070-94e7-036f95366b88" },
  { year: "2011", title: "Overcomers' Convention", image: "https://firebasestorage.googleapis.com/v0/b/bcs-website-assets.appspot.com/o/pastevent%2Fpastevent5.jpeg?alt=media&token=09ef570e-1b72-4838-a87b-38b1a98b846c" },
  { year: "2012", title: "Abba Father", image: "https://firebasestorage.googleapis.com/v0/b/bcs-website-assets.appspot.com/o/pastevent%2Fpastevent1.jpeg?alt=media&token=8e81abae-3f1b-4070-94e7-036f95366b88" },
  { year: "2013", title: "Salt of the Earth", image: "https://firebasestorage.googleapis.com/v0/b/bcs-website-assets.appspot.com/o/pastevent%2Fpastevent5.jpeg?alt=media&token=09ef570e-1b72-4838-a87b-38b1a98b846c" },
  { year: "2014", title: "Hidden Manner", image: "https://firebasestorage.googleapis.com/v0/b/bcs-website-assets.appspot.com/o/pastevent%2Fpastevent1.jpeg?alt=media&token=8e81abae-3f1b-4070-94e7-036f95366b88" },
  { year: "2015", title: "Powerful Remnant", image: "https://firebasestorage.googleapis.com/v0/b/bcs-website-assets.appspot.com/o/pastevent%2Fpastevent5.jpeg?alt=media&token=09ef570e-1b72-4838-a87b-38b1a98b846c" },
  { year: "2016", title: "Olumba's Supreme Temple", image: "https://firebasestorage.googleapis.com/v0/b/bcs-website-assets.appspot.com/o/pastevent%2Fpastevent1.jpeg?alt=media&token=8e81abae-3f1b-4070-94e7-036f95366b88" },
  { year: "2018", title: "Centenary of the Ancient of Days", image: "https://firebasestorage.googleapis.com/v0/b/bcs-website-assets.appspot.com/o/pastevent%2Fpastevent5.jpeg?alt=media&token=09ef570e-1b72-4838-a87b-38b1a98b846c" },
  { year: "2019", title: "Heavenly Father", image: "https://firebasestorage.googleapis.com/v0/b/bcs-website-assets.appspot.com/o/pastevent%2Fpastevent1.jpeg?alt=media&token=8e81abae-3f1b-4070-94e7-036f95366b88" },
  { year: "2023", title: "Divine Numbering of the Elects", image: "https://firebasestorage.googleapis.com/v0/b/bcs-website-assets.appspot.com/o/pastevent%2Fevent9.jpeg?alt=media&token=9cdd5646-08e6-4b16-8cc8-7bc923d5de19" },
];

function PastEvents() {
  const [activeIndex, setActiveIndex] = useState(null);
  const [apiPastEvents, setApiPastEvents] = useState([]);

  React.useEffect(() => {
    const loadApiEvents = async () => {
      try {
        const data = await fetchFromAPI("/events") || [];
        
        // Date passed by one week and a day = 8 days ago
        const eightDaysAgo = new Date();
        eightDaysAgo.setDate(eightDaysAgo.getDate() - 8);
        eightDaysAgo.setHours(0, 0, 0, 0);

        const filteredOldEvents = data
          .filter(e => {
            const dateStr = e.eventDate || e.date || e.datetime || e.dateTime || e.timestamp;
            if (!dateStr) return false;
            const eventDate = new Date(dateStr);
            return eventDate < eightDaysAgo;
          })
          .map(e => {
            const dateObj = new Date(e.eventDate || e.date || e.datetime || e.dateTime);
            return {
              year: dateObj.getFullYear().toString(),
              title: e.title,
              image: e.bannerImage || "https://firebasestorage.googleapis.com/v0/b/bcs-website-assets.appspot.com/o/pastevent%2Fpastevent5.jpeg?alt=media&token=09ef570e-1b72-4838-a87b-38b1a98b846c",
              originalId: e.id || e._id
            };
          });

        setApiPastEvents(filteredOldEvents);
      } catch (err) {
        console.error("Failed fetching past API events", err);
      }
    };
    loadApiEvents();
  }, []);

  const toggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  // Combine original array with newly fetched API past events
  const combinedEvents = [...accordioni, ...apiPastEvents];

  return (
    <div className="bg-white min-h-screen w-full overflow-x-hidden">

      {/* ── Hero Banner ── */}
      <div className="relative w-full h-[40vh] md:h-[50vh] mt-32 md:mt-36 overflow-hidden">
        <img
          src="https://firebasestorage.googleapis.com/v0/b/bcs-public-portal.appspot.com/o/BCS_WEBITE_ASSETS%2Fpe.jpg?alt=media&token=a972023e-392f-4b95-9235-c456598dadc7"
          alt="Past Events"
          className="w-full h-full object-cover object-center"
        />

      </div>

      {/* ── Section Label ── */}
      <div className="flex items-center gap-2 justify-center mt-16 mb-4">
        <span className="block w-7 h-px bg-red-600" />
        <span className="text-red-600 text-xs font-semibold tracking-widest uppercase">
          Past Events
        </span>
        <span className="block w-7 h-px bg-red-600" />
      </div>
      <h2 className="text-center text-3xl md:text-4xl font-bold text-gray-900 mb-2">
        The Road We Have Walked
      </h2>
      <p className="text-center text-gray-400 text-sm mb-16 px-4">
        Milestones of faith across the decades
      </p>

      {/* ── Snake Roadmap ── */}
      <div className="max-w-4xl mx-auto px-4 md:px-10 pb-24 relative">

        {/* Vertical center line on mobile */}
        <div className="absolute left-1/2 -translate-x-1/2 top-0 bottom-0 w-px bg-gray-200 md:hidden" />

        {combinedEvents.map((event, index) => {
          const isLeft = index % 2 === 0;
          const isActive = activeIndex === index;

          return (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: index * 0.04 }}
              className={`relative flex items-center mb-10 md:mb-0 ${isLeft ? "md:flex-row" : "md:flex-row-reverse"
                } flex-col md:gap-0`}
            >

              {/* ── Card ── */}
              <div className={`w-full md:w-[44%] ${isLeft ? "md:pr-10" : "md:pl-10"}`}>
                <button
                  onClick={() => toggle(index)}
                  className={`w-full text-left border rounded-sm p-5 transition-all duration-300 ${isActive
                    ? "border-red-400 bg-red-50"
                    : "border-gray-200 bg-white hover:border-red-300 hover:bg-gray-50"
                    }`}
                >
                  <div className="flex items-center justify-between gap-3">
                    <div>
                      <span className="text-red-500 text-xs font-bold tracking-widest uppercase">
                        {event.year}
                      </span>
                      <h3 className="text-gray-900 font-semibold text-sm mt-0.5 leading-snug">
                        {event.title}
                      </h3>
                    </div>
                    <span
                      className={`flex-shrink-0 w-7 h-7 flex items-center justify-center rounded-full border transition-all duration-300 text-xs ${isActive
                        ? "bg-red-500 border-red-500 text-white"
                        : "border-gray-300 text-gray-400"
                        }`}
                    >
                      {isActive ? "−" : "+"}
                    </span>
                  </div>

                  {/* Expanded image */}
                  {isActive && (
                    <motion.div
                      initial={{ opacity: 0, height: 0 }}
                      animate={{ opacity: 1, height: "auto" }}
                      exit={{ opacity: 0, height: 0 }}
                      transition={{ duration: 0.3 }}
                      className="mt-4 overflow-hidden"
                    >
                      <img
                        src={event.image}
                        alt={event.title}
                        className="w-full h-44 object-cover rounded-sm"
                      />
                    </motion.div>
                  )}
                </button>
              </div>

              {/* ── Centre Node ── */}
              <div className="md:w-[12%] flex items-center justify-center my-3 md:my-0 relative z-10">
                {/* Connecting horizontal line */}
                <div className={`hidden md:block absolute top-1/2 -translate-y-1/2 h-px bg-gray-200 w-full`} />
                {/* Dot */}
                <div
                  className={`relative z-10 w-10 h-10 rounded-full flex items-center justify-center text-[10px] font-black border-2 transition-all duration-300 ${isActive
                    ? "bg-red-600 border-red-600 text-white"
                    : "bg-white border-gray-300 text-gray-400"
                    }`}
                >
                  {String(index + 1).padStart(2, "0")}
                </div>
              </div>

              {/* ── Empty spacer for opposite side ── */}
              <div className="hidden md:block md:w-[44%]" />

              {/* ── Vertical connector between rows ── */}
              {index < combinedEvents.length - 1 && (
                <div
                  className={`hidden md:block absolute top-1/2 h-full w-px bg-gray-200 left-1/2 -translate-x-1/2 z-0`}
                  style={{ top: "50%" }}
                />
              )}
            </motion.div>
          );
        })}

        {/* End cap */}
        <div className="flex flex-col items-center mt-8 gap-2">
          <div className="w-px h-10 bg-gray-200" />
          <div className="w-4 h-4 rounded-full bg-red-600" />
          <p className="text-xs text-gray-400 tracking-widest uppercase mt-2">
            More to Come
          </p>
        </div>
      </div>
    </div>
  );
}

export default PastEvents;